import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ConversationMessagesStore } from 'widgets/ConversationMessages'

export const useEventVoicemailReceived = (conversationMessageStore: ConversationMessagesStore) => {
  const { websocket, conversationStore } = useEntitiesContext()
  const handler = (data: IResponseEventMessage) => {
    conversationStore.updateItem(data.conversation)
    if (data.message.conversation_id === conversationMessageStore.conversationId) {
      conversationMessageStore.setItems([data.message])
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.VoicemailReceived, handler), [])
}
